(function () {
  var slider = document.querySelector('.js-tiles-slider')
  var prevBtn = document.querySelector('.js-tiles-prev')
  var nextBtn = document.querySelector('.js-tiles-next')

  if (!slider || !prevBtn || !nextBtn) return

  function getScrollAmount() {
    var tile = slider.querySelector('.ctr-megamenu-shop__tile')
    if (!tile) return 289
    var gap = parseFloat(getComputedStyle(slider).gap) || 26
    return tile.offsetWidth + gap
  }

  var nav = document.querySelector('.ctr-megamenu-shop__tiles-nav')
  var tilesHeader = document.querySelector('.ctr-megamenu-shop__tiles-header')

  function updateNav() {
    var needsSlider = slider.scrollWidth > slider.clientWidth

    if (tilesHeader) tilesHeader.style.display = needsSlider ? '' : 'none'
    if (nav) nav.style.display = needsSlider ? '' : 'none'

    if (!needsSlider) return

    var scrollLeft = Math.round(slider.scrollLeft)
    var maxScroll = slider.scrollWidth - slider.clientWidth

    prevBtn.disabled = scrollLeft <= 0
    nextBtn.disabled = scrollLeft >= maxScroll - 1
  }

  slider.addEventListener('scroll', updateNav, { passive: true })
  window.addEventListener('resize', updateNav)
  updateNav()

  prevBtn.addEventListener('click', function () {
    slider.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' })
  })

  nextBtn.addEventListener('click', function () {
    slider.scrollBy({ left: getScrollAmount(), behavior: 'smooth' })
  })
})()

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ctr-megamenu-shop__tile').forEach(function (tile) {
    var hoverImg = tile.querySelector('.ctr-megamenu-shop__tile-image--hover')
    if (hoverImg && hoverImg.getAttribute('src')) {
      tile.classList.add('has-hover-image')
    }
  })
})

;(function () {
  if (!window.Shopify || !Shopify.designMode) return

  var megamenu = document.querySelector('.ctr-megamenu-shop--design-mode.js-shop-megamenu')
  if (!megamenu) return

  var sectionId = megamenu.dataset.sectionId
  if (!sectionId) return

  var editorVisibleClass = 'ctr-megamenu-shop--editor-visible'

  function showInEditor() {
    megamenu.classList.add(editorVisibleClass)
    megamenu.setAttribute('aria-hidden', 'false')
  }

  function hideInEditor() {
    megamenu.classList.remove(editorVisibleClass)
    megamenu.setAttribute('aria-hidden', 'true')
  }

  function isThisSection(event) {
    return event.detail && event.detail.sectionId === sectionId
  }

  document.addEventListener('shopify:section:select', function (event) {
    if (isThisSection(event)) showInEditor()
  })

  document.addEventListener('shopify:block:select', function (event) {
    if (isThisSection(event)) showInEditor()
  })

  document.addEventListener('shopify:section:deselect', function (event) {
    if (isThisSection(event)) hideInEditor()
  })

  document.addEventListener('shopify:section:load', function (event) {
    if (!isThisSection(event)) return

    megamenu = document.querySelector(
      '.ctr-megamenu-shop--design-mode.js-shop-megamenu[data-section-id="' + sectionId + '"]',
    )
    if (!megamenu) return

    showInEditor()
  })
})()